import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";
import { contentService } from "./contentService";

export interface StripeCheckoutSession {
  status: string;
  customerId: string;
  email: string;
  title: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isRefunded: any;
}

class PaymentService {
  async validateStripePayment(
    sessionId: string,
    userStripeId: string,
    contentId: string,
  ): Promise<boolean> {
    const getCheckoutSession = httpsCallable(functions, "getCheckoutSession");
    const checkoutSession = await getCheckoutSession({
      sessionId,
    }).then((result) => result.data as StripeCheckoutSession);

    const { status, customerId, isRefunded } = checkoutSession;

    return (
      status === "complete" &&
      userStripeId === customerId &&
      !isRefunded &&
      !!contentId
    );
  }

  async processStripePayment(
    uid: string,
    sessionId: string,
    contentId: string,
    chapter: string,
  ): Promise<void> {
    const userProf = await contentService.getUser(uid);
    const stripeId = userProf?.stripeId;

    if (!stripeId) {
      throw new Error("User stripe ID not found");
    }

    const isValid = await this.validateStripePayment(
      sessionId,
      stripeId,
      contentId,
    );
    if (!isValid) {
      throw new Error("Invalid payment session");
    }

    await contentService.setUserContent(uid, contentId, chapter, {
      type: "stripe",
      sessionId: sessionId,
    });
  }

  async processPayPayPayment(
    uid: string,
    contentId: string,
    chapter: string,
    merchantPaymentId: string,
  ): Promise<boolean> {
    const checkPurchasedAndSaveContents = httpsCallable<
      {
        uid: string;
        contentId: string;
        chapter: string;
        merchantPaymentId: string;
      },
      {
        success: boolean;
      }
    >(functions, "checkPurchasedAndSaveContentsV2");

    const response = await checkPurchasedAndSaveContents({
      uid,
      contentId,
      chapter,
      merchantPaymentId,
    });

    return response.data.success;
  }

  async refundStripePayment(sessionId: string): Promise<void> {
    await contentService.refund(sessionId);
  }
}

export const paymentService = new PaymentService();
